import React, { Component } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Symbol_Toyota from "../../assets/images/toyota_icon_red.png";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import "./commonHeader.css";
import { BrowserRouter, NavLink, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class CommonHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  render() {
    return (
      // <BrowserRouter>
      //   <Switch>
      <div>
        <div className="navbarHeader">
          <Navbar className="navBar">
            <Container className="container">
              <Navbar.Brand>
                <span className="brand">
                  <img
                    className="image_icon"
                    src={Symbol_Toyota}
                    width="37"
                    height="37"
                  />
                  <span
                    className="userName"
                    style={{ fontFamily: "Toyota Type" }}
                  >
                    Welcome, {this.props.username}
                  </span>
                </span>
              </Navbar.Brand>

              <Nav className="modalButton me-auto" onClick={this.handleShow}>
                <i className="fa fa-bars" style={{ color: "#f02" }}></i>
              </Nav>
              <Nav className="Nlinks me-auto">
                {this.props.roles.includes("EDOC TME AF USER") ? (
                  <Dropdown className="dropdownLinks">
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      style={{
                        backgroundColor: "#E50000",
                        border: "#E50000",
                        height: "39px",
                      }}
                    >
                      {this.props.activeLink}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {this.props.roles.includes("EDOC INVOICE ADMIN") ? (
                        <Dropdown.Item
                          as={NavLink}
                          to="/auditorAdmin"
                          className="nav_Links"
                          activeClassName="activeNavComponent"
                        >
                          Auditor Setup
                        </Dropdown.Item>
                      ) : null}

                      {this.props.roles.includes("EDOC TRD USER") ||
                      this.props.roles.includes("EDOC NMSC TRD USER") ||
                      this.props.roles.includes("EDOC TME AF USER") ? (
                        <Dropdown.Item
                          as={NavLink}
                          to="/search"
                          className="nav_Links"
                          activeClassName="activeNavComponent"
                        >
                          After Sales Shipment
                        </Dropdown.Item>
                      ) : null}

                      {this.props.roles.includes("EDOC TME USER") ||
                      this.props.roles.includes("EDOC NMSC USER") ||
                      this.props.roles.includes("EDOC TME AF USER") ? (
                        <Dropdown.Item
                          as={NavLink}
                          to="/invoiceSearch"
                          onClick={this.handleInvoice}
                          className="nav_Links"
                          activeClassName="activeNavComponent"
                        >
                          After Sales Invoice
                        </Dropdown.Item>
                      ) : null}
                      {this.props.roles.includes("EDOC VLG TME USER") ||
                      this.props.roles.includes("EDOC VLG NMSC USER") ||
                      this.props.roles.includes("EDOC TME AF USER") ? (
                        <Dropdown.Item
                          as={NavLink}
                          to="/salesInvoice"
                          className="nav_Links"
                          activeClassName="activeNavComponent"
                        >
                          Vehicle Sales Invoices
                        </Dropdown.Item>
                      ) : null}

                      {/* {this.props.roles.includes("EDOC TME AF USER") ? (
                        <Dropdown.Item
                          as={NavLink}
                          to="/invoicingSystem"
                          className="nav_Links"
                          activeClassName="activeNavComponent"
                        >
                          VLG TME Admin
                        </Dropdown.Item>
                      ) : null} */}
                    </Dropdown.Menu>
                  </Dropdown>
                ) : (
                  <Button
                    style={{
                      backgroundColor: "#E50000",
                      border: "#E50000",
                      height: "39px",
                    }}
                    className="dropdownLinks"
                  >
                    {this.props.activeLink}
                  </Button>
                )}

                {/* this.props.invoice=="Yes"    */}
                <NavLink
                  to="/logout"
                  className="nav_Links"
                  activeClassName="activeNavComponent"
                  onClick={this.props.logoutUser}
                >
                  <div className="dropdown"></div>
                  <i
                    className="fa fa-sign-out"
                    aria-hidden="true"
                    style={{ marginLeft: "1px" }}
                  ></i>
                  LogOut
                </NavLink>
              </Nav>
            </Container>
          </Navbar>
        </div>

        <Modal
          show={this.state.show}
          onHide={this.handleClose}
          className="modalDropdown"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {" "}
              <span className="userName" style={{ fontFamily: "Toyota Type" }}>
                Welcome, {this.props.username}
              </span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {" "}
            <Nav className="ModalLinks me-auto">
              {this.props.roles.includes("EDOC INVOICE ADMIN") ? (
                <NavLink
                  to="/auditorAdmin"
                  className="nav_Links"
                  activeClassName="activeNavComponent"
                >
                  Auditor Setup
                </NavLink>
              ) : null}

              {this.props.roles.includes("EDOC TRD USER") ||
              this.props.roles.includes("EDOC NMSC TRD USER") ||
              this.props.roles.includes("EDOC TME AF USER") ? (
                <NavLink
                  to="/search"
                  className="nav_Links"
                  activeClassName="activeNavComponentModal"
                >
                  After Sales Shipment
                </NavLink>
              ) : null}

              {/* this.props.invoice=="Yes"    */}

              {this.props.roles.includes("EDOC TME USER") ||
              this.props.roles.includes("EDOC NMSC USER") ||
              this.props.roles.includes("EDOC TME AF USER") ? (
                <NavLink
                  to="/invoiceSearch"
                  onClick={this.handleInvoice}
                  className="nav_Links"
                  activeClassName="activeNavComponentModal"
                >
                  After Sales Invoice
                </NavLink>
              ) : null}

              {this.props.roles.includes("EDOC VLG TME USER") ||
              this.props.roles.includes("EDOC TME AF USER") ||
              this.props.roles.includes("EDOC VLG NMSC USER") ? (
                <NavLink
                  to="/salesInvoice"
                  className="nav_Links"
                  activeClassName="activeNavComponentModal"
                >
                  Vehicle Sales Invoices
                </NavLink>
              ) : null}

              {/* {this.props.roles.includes("EDOC VLG TME USER") ? (
                <NavLink
                  to="/invoicing System"
                  className="nav_Links"
                  activeClassName="activeNavComponentModal"
                >
                  Invoicing System
                </NavLink>
              ) : null} */}
              <NavLink
                to="/logout"
                className="nav_Links"
                activeClassName="activeNavComponentModal"
                onClick={this.props.logoutUser}
              >
                <div class="dropdown"></div>
                <i
                  className="fa fa-sign-out"
                  aria-hidden="true"
                  style={{ marginLeft: "1px" }}
                ></i>
                LogOut
              </NavLink>
            </Nav>
          </Modal.Body>
        </Modal>
        <span
          style={{
            fontSize: "20px",
            marginBottom: "2rem",
            fontStyle: "normal",
            marginLeft: "2rem",
            fontFamily: "Toyota Type",
            display: "block",
          }}
        >
          {this.props.page}
        </span>
      </div>
      //   </Switch>
      // </BrowserRouter>
    );
  }
}
// function mapStateToProps(state) {
//   return {
// };
// }

// export default withRouter(connect(mapStateToProps)(CommonHeader));
export default CommonHeader;
